import { render } from "./OnlineCourses.vue?vue&type=template&id=abab5e22&scoped=true"
import script from "./OnlineCourses.vue?vue&type=script&lang=js"
export * from "./OnlineCourses.vue?vue&type=script&lang=js"

import "./OnlineCourses.vue?vue&type=style&index=0&id=abab5e22&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abab5e22"]])

export default __exports__